import Vue from 'vue';

import Brand from './Brand';

Vue.component('brku-loader-brand', Brand);